import React, { useState } from "react";
import { DoubleArrowOutlined } from "@material-ui/icons";
import ButtonIconTooltipCompleo from "Components/ButtonIconTooltipCompleo";
import { JobApprovalStatusDialog } from "./JobApprovalStatusDialog";
import { useTranslation } from "react-i18next";

interface JobApprovalStatusProps {
    jobId: string;
    jobTitle: string;
    className?: string;
}

export function JobApprovalStatus({
    jobId,
    jobTitle,
    className
}: JobApprovalStatusProps) {
    const [open, setOpen] = useState(false);
    const [t, i18n, readyTranslation] = useTranslation("JOBAPPROVALSTATUS", {
        useSuspense: false
    });
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    if (!readyTranslation) {
        return null;
    }
    return (
        <>
            <ButtonIconTooltipCompleo
                className={className}
                label={t("buttonOpen")}
                onClick={handleOpen}
            >
                <DoubleArrowOutlined />
            </ButtonIconTooltipCompleo>

            {open && (
                <JobApprovalStatusDialog
                    open={open}
                    onClose={handleClose}
                    jobId={jobId}
                    jobTitle={jobTitle}
                    t={t}
                />
            )}
        </>
    );
}
